<template>
    <div>
        <v-row>
            <v-col cols="5">
                <SearchTextfield placeholder="레코딩 파일을 검색해주세요." :search="search" />
            </v-col>

            <v-col class="text-right mb-2">
                <IconButton icon="mdi-autorenew" class="mr-2" @click="refresh" small />
                <IconButton icon="mdi mdi-download" class="mr-2" @click="download" small />
                <IconButton icon="mdi mdi-file-move-outline" class="mr-2" @click="moveTo" small />
                <IconButton icon="mdi mdi-trash-can-outline" @click="deleteItem" small />
            </v-col>


        </v-row>

        <Alert v-if="showAlert" :message="message" :message-type="messageType"></Alert>

        <v-data-table :headers="headers.recordHeaders" :items="recordList" :items-per-page="10"
            :footer-props="{ itemsPerPageOptions: [10, 20, 30, -1], itemsPerPageText: 'All' }" class="data-table"
            :disable-sort="true" show-select :search="search" :loading="loadingRefresh" v-model="sel" item-key="id"
            @input="enterSelect($event)">


            <template v-slot:item.stream_name="{ item }">
                {{ item.stream_name }}
            </template>

            <template v-slot:item.record_filename="{ item }">
                {{ item.record_filename }}
            </template>

            <template v-slot:item.record_starttime="{ item }">
                <!-- {{ formatTime(item.record_starttime) }} -->
                {{ item.record_starttime }}
            </template>

            <template v-slot:item.record_endtime="{ item }">
                <!-- {{ formatTime(item.record_endtime) }} -->
                {{ item.record_endtime }}
            </template>

        </v-data-table>


        <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />


    </div>
</template>

<script>
import LiveStreamApi from "@/api/livestream/LiveStreamApi";
import Input from '@/components/ui/form/FormInput.vue';
import TextButton from '@/components/ui/button/TextButton.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import SearchTextfield from '@/components/ui/form/SearchTextfield.vue';
import Alert from '@/components/app/AppAlert.vue';
import { mapGetters } from 'vuex';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";


export default {
    components: {
        Input,
        TextButton,
        IconButton,
        SearchTextfield,
        Alert,
        AppSnackbar
    },
    data() {
        return {
            recordList: [],
            search: null,
            loadingRefresh: false,
            sel: [],
            message: null,
            messageType: null,
            showAlert: false,
            snackbar: false,
            snackbarText: '',
            snackbarError: false,
            snackbarErrorText: '',
        }
    },
    methods: {
        async getlist() {
            try {
                const ip = `${window.location.protocol}//${window.location.host}`;

                this.loadingRefresh = true;
                const res = await LiveStreamApi.getRecordListApi(ip);
                // console.log("확인 => ", res);

                if (res.status === 1) {
                    this.recordList = res.data;
                    this.loadingRefresh = false;
                }
            } catch (error) {
                console.error('[recording - getlist] error', error);
            }
        },
        enterSelect(val) {
            //console.log("체크값 확인 -> ", val);
        },
        refresh() {
            this.getlist();
        },
        async download() {
            try {
                if (this.sel.length === 0) {
                    this.showAlert = true;
                    setTimeout(() => {
                        this.messageType = "warning";
                        this.message = "선택한 항목이 없습니다."
                        this.showAlert = false;
                    }, 2000);
                }
                else {
                    const files = this.sel.map(e => e.record_filename);
                    try {
                        for (const file of files) {
                            const data = {
                                params: { items: file },
                                responseType: 'blob'
                            }
                            const res = await LiveStreamApi.recordDownloadApi(data);
                            const url = window.URL.createObjectURL(new Blob([res]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', file);
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);

                            // const url = res.data.url;
                            // const link = document.createElement('a');
                            // link.href = url;
                            // link.setAttribute('download', file); 
                            // document.body.appendChild(link);
                            // link.click();
                            // document.body.removeChild(link);
                        }
                        this.sel = [];
                        this.refresh();
                    } catch (error) {
                        console.error('[recording download] error :', error);
                    }
                }
            } catch (error) {
                console.error('[recording - download] error', error);
            }
        },
        async moveTo() {
            try {
                if (this.sel.length === 0) {
                    this.showAlert = true;
                    setTimeout(() => {
                        this.messageType = "warning";
                        this.message = "선택한 항목이 없습니다."
                        this.showAlert = false;
                    }, 2000);
                } else {
                    const items = this.sel.map(e => e.record_filename);
                    const res = await LiveStreamApi.recordMoveToApi(items);
                    if(res.status == 1){
                        this.snackbarText = '이동 성공';
                    } else {
                        this.snackbarText = '이동 실패';
                    }
                    this.snackbarError = false;
                    this.snackbar = true;
                    this.sel = [];
                    this.refresh();
                }
            } catch (error) {
                console.error('[recording - moveTo] error', error);
            }
        },
        async deleteItem() {
            try {
                if (this.sel.length === 0) {
                    this.showAlert = true;
                    setTimeout(() => {
                        this.messageType = "warning";
                        this.message = "선택한 항목이 없습니다."
                        this.showAlert = false;
                    }, 2000);
                } else {
                    const items = this.sel.map(e => e.record_filename);
                    const res = await LiveStreamApi.recordDeleteApi(items);
                    if (res.status === 1) {
                        this.snackbarText = '삭제 성공';
                    } else {
                        this.snackbarText = '삭제 실패';
                    }
                    this.snackbarError = false;
                    this.snackbar = true;
                    this.sel = [];
                    this.refresh();
                }
            } catch (error) {
                console.error('[recording - deleteItem] error', error);
                this.snackbarText = '삭제 실패';
                this.snackbarError = true;
                this.snackbar = true;
            }
        },
        async wowzadbCheck() {
            const response = await LiveStreamApi.wowzaCheckApi();
            const statusFail = response.status;

            if (statusFail === 0) {
                this.$router.push('/mediaerror');
            } else if (statusFail === 3) {
                this.$router.push('/mediaerror');
            } else {
                this.getlist();
            }
        },
    },
    computed: {
        ...mapGetters('objectData', ['getHeaders', 'getStandard']),
        headers() {
            return {
                recordHeaders: this.getHeaders('recordTable'),
            }
        },
    },
    beforeMount() {
        this.getlist();
    },
    mounted() {
        this.wowzadbCheck();
    },
}
</script>

<style lang="scss" scoped></style>